/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useEffect, useState } from 'react';
import {
  IAny,
  IRequestContext
} from '../../DashboardKPIWidgets/IEnergyManagementProps';
import useConnectorAndDynamicProps from '../../shared/useConnectorAndDynamicProps/useConnectorAndDynamicProps';
import {
  convertUtilityProvidersToOptions,
  debounce,
  isObjectEmpty,
  SpecialCharacter
} from '../../shared/Utils/Utils';
import descriptors from '../../../locales/en-US/descriptors';
import { useTranslation } from '@scuf/localization';
import { IUtilityProviders } from '../IUtilityService';
import { Search, Icon, Tooltip } from '@scuf/common';
import { IResult } from '@scuf/common/dist/components/Search/ISearchProps';
import { MAGIC_VALUE, UtilityType } from '../../shared/Utils/Constants';
import { isLoadingCheck } from '../../shared/Utils/UtilityViewDetails';
import { connectorConfigCheck } from '../ConnectTab/ConnectTabUtils';
import { v4 as uuid4 } from 'uuid';
import { useUtilityAccountContext } from '../../../context/UtilityAccountContext/UtilityAccountContext';

interface IChooseServiceTab {
  bearerToken?: string;
  requestContext: IRequestContext;
  SetSelectedUtilityProvider: Function;
  SelectedUtilityProvider: IUtilityProviders;
  utilityTyp?: string;
  setIsSpecialCharacter: IAny;
  isSpecialCharacter: boolean;
  isDataAvailablebill: any;
  valueDetails: IAny;
}
interface IUtilityProviderRes {
  data: IUtilityProviders[];
}
function Editdetailstab(props: IChooseServiceTab) {
  const d = descriptors.energyManagement;
  const [t] = useTranslation();
  const {
    bearerToken,
    SetSelectedUtilityProvider,
    SelectedUtilityProvider,
    isDataAvailablebill,
    valueDetails
  } = props;
  let { requestContext } = props;
  const [state, dispatch] = useUtilityAccountContext();
  //   const { showModal } = state;
  const {
    showModal,
    showConversionModal,
    selectedUtility,
    editDetailsModal
  } = state;
  const minimumSearchCharacter = 3;
  const [results, setResults] = useState<IResult[]>([]);
  const [SearchKeyword, setSearchKeyword] = useState(
    selectedUtility.providerName
  );

  const [displaySelected, setDisplaySelected] = useState('');
  const connectorConfig = {
    name: connectorConfigCheck(SearchKeyword)
  };
  requestContext = {
    ...requestContext,
    context: {
      ...requestContext.context,
      searchKeyword: SearchKeyword
    }
  };
  let [dataConnector] = useConnectorAndDynamicProps({
    connectorConfig,
    requestContext,
    bearerToken
  });
  const { all, loading, error, status } = dataConnector.data;
  const UtilityProviderResponse: IUtilityProviderRes = (all as unknown) as IUtilityProviderRes;
  let isDataAvailable: boolean;
  if (UtilityProviderResponse) isDataAvailable = true;
  else isDataAvailable = false;
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [, setStatusCode] = useState<number | null>(status);
  const [, setErrorInfo] = useState(error);
  const [, setData] = useState({});

  useEffect(() => {
    props.utilityTyp === 'Automated' &&
      SetSelectedUtilityProvider({} as IUtilityProviders);
    setResults([]);
    if (SearchKeyword.length >= minimumSearchCharacter) {
      dataConnector && dataConnector.actions && dataConnector.actions.getAll();
    }
  }, [SearchKeyword]);

  useEffect(() => {
    isObjectEmpty(SelectedUtilityProvider) && setDisplaySelected('');
  }, [SelectedUtilityProvider]);

  const saveDataForManual = () => {
    if (SearchKeyword && props.utilityTyp === 'Manual') {
      props.setIsSpecialCharacter(false);
      let isPresent = false;
      let ind: IAny = '';
      if (
        UtilityProviderResponse &&
        UtilityProviderResponse.data &&
        UtilityProviderResponse.data.length
      ) {
        UtilityProviderResponse?.data.forEach((res: IAny, index: number) => {
          if (res.utilityProviderName === SearchKeyword) {
            isPresent = true;
            ind = index;
          }
        });
      }
      let provId = uuid4();
      if (isPresent) {
        provId = UtilityProviderResponse?.data[ind].utilityProviderId;
      }

      setDisplaySelected('');
      SetSelectedUtilityProvider({
        utilityProviderName: SearchKeyword,
        utilityProviderId: provId
      });
    }
  };

  useEffect(() => {
    setIsLoading(loading);

    if (!isDataAvailable && SearchKeyword && props.utilityTyp === 'Manual') {
      props.setIsSpecialCharacter(false);
      SetSelectedUtilityProvider({
        utilityProviderName: SearchKeyword,
        utilityProviderId: uuid4()
      });
    }
    if ((isDataAvailable || error || status) && !loading) {
      if (isDataAvailable) {
        setData(UtilityProviderResponse);

        saveDataForManual();
        let UtilityProviders = convertUtilityProvidersToOptions(
          UtilityProviderResponse?.data
        );
        let searchresults = UtilityProviders.map((provider) => {
          return {
            title: provider.text,
            value: provider.value
          };
        });
        let filteredResults = searchresults.filter((searchEle) => {
          return searchEle.title
            .toLowerCase()
            .includes(SearchKeyword.toLowerCase());
        });
        setResults(filteredResults);
      }
      setErrorInfo(error);
      setStatusCode(status);
    }
  }, [isDataAvailable, loading]);

  const SearchProvider = async (value: string) => {
    if (
      value &&
      value.length <= MAGIC_VALUE.HUNDRED &&
      (props.utilityTyp === 'Manual' || !SpecialCharacter(value))
    ) {
      setSearchKeyword(value.trim());
    }
  };

  const debounceTimeLimit = 500;
  const debouncedSearch = debounce(SearchProvider, debounceTimeLimit);

  return (
    <div className="edit-detail-service-tab">
      <p>
        {isDataAvailablebill?.length == 0
          ? t(d.EDITDETAILNOTE)
          : t(d.EDITDETAILWHENBILLEXISTS)}
      </p>
      <label className="edit-detail-provider-label">
        {t(d.UTILITYPROVIDERLABEL)}*
      </label>
      <div className="select-loader-wrapper">
        <Search
          placeholder={t(d.SEARCHPROVIDER)}
          noResultsMessage={isLoadingCheck(isLoading, t)}
          results={results}
          value={SelectedUtilityProvider.utilityProviderName}
          //value={SearchKeyword}
          onSearchChange={(value) => {
            debouncedSearch(value);
          }}
          onResultSelect={(value) => {
            setDisplaySelected(value.title);
            SetSelectedUtilityProvider(JSON.parse(value.value));
          }}
          //disabled={(isDataAvailablebill?.length == 0 ? false : true) || ((valueDetails.status=== 'NOMINATED' || valueDetails.status=== 'MetersMismatch' || valueDetails.status=== 'SUCCESSFUL_DELIVERED' || valueDetails.status=== 'SUCCESSFUL_ENROLLED') === false ? false : true)}
          disabled={
            selectedUtility.integrationType === 'Automatic'
              ? true
              : isDataAvailablebill?.length == 0
              ? (valueDetails.status === 'NOMINATED' ||
                  valueDetails.status === 'MetersMismatch' ||
                  valueDetails.status === 'SUCCESSFUL_DELIVERED' ||
                  valueDetails.status === 'SUCCESSFUL_ENROLLED') === false
                ? false
                : true
              : true
          }
        />
        {props.isSpecialCharacter && (
          <span className="special-character-error">
            Provider name cannot contain special character
          </span>
        )}
      </div>
    </div>
  );
}

export default Editdetailstab;
